'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _StringColumn2 = require('./StringColumn');

var _StringColumn3 = _interopRequireDefault(_StringColumn2);

var _globalize = require('globalize');

var _globalize2 = _interopRequireDefault(_globalize);

var _odataUri = require('../../utils/odata-uri');

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DateColumn = function (_StringColumn) {
	_inherits(DateColumn, _StringColumn);

	function DateColumn() {
		_classCallCheck(this, DateColumn);

		return _possibleConstructorReturn(this, (DateColumn.__proto__ || Object.getPrototypeOf(DateColumn)).apply(this, arguments));
	}

	_createClass(DateColumn, [{
		key: 'displayValue',
		value: function displayValue(value) {
			if (value !== null) {
				value = new Date(value);
				if (isNaN(value.getTime())) {
					value = null;
				}
			}
			return this._getFormattedValue(value);
		}
	}, {
		key: '_getFormattedValue',
		value: function _getFormattedValue(value) {
			var formatted = _globalize2.default.format(value, this.options.formatString);
			return typeof formatted === 'string' ? formatted.replace(' ', '&nbsp;') : formatted;
		}
	}, {
		key: 'createEditor',
		value: function createEditor(value) {
			return (0, _jquery2.default)('<input class="table-input" type="text" data-provider="datepicker" data-vertical="bottom">').val(value || '').get(0);
		}

		// -------------- FILTERS --------------------

	}, {
		key: 'createFilter',
		value: function createFilter() {
			return '<div class="input-daterange input-group dtp-date" data-provider="datepicker">\n    <input type="text" class="form-control input-sm table-filter" data-vertical="bottom">\n    <span class="input-group-addon">-</span>\n    <input type="text" class="form-control input-sm table-filter" data-vertical="bottom">\n</div>';
		}
	}, {
		key: 'setFilterValue',
		value: function setFilterValue(value) {
			var split = value.split('~', 2);
			var filter = this.column.filter();
			filter.find('input.table-filter:first').val(split[0] || '');
			filter.find('input.table-filter:last').val(split[1] || '');
		}
	}, {
		key: 'buildFilterExpression',
		value: function buildFilterExpression(fieldName, columnFilter) {
			var fnFormatValue = function fnFormatValue(v, restOfDay) {
				var date = (0, _moment2.default)(v, ["L LT", "L"]);

				if (restOfDay) {
					date = date.add(1, 'days').subtract(1, 'seconds');
				}

				return date.toISOString();
			};

			// Currently, we cannot use global search for date and numeric fields (exception on the OData service side)
			// However, individual column filters are supported in form lower~upper
			if (columnFilter.indexOf("~") > -1) {
				var ranges = columnFilter.split("~");
				var rangeQuery = [];
				if (ranges[0]) {
					rangeQuery.push("(" + fieldName + " ge " + fnFormatValue(ranges[0]) + ")");
				}
				if (ranges[1]) {
					rangeQuery.push("(" + fieldName + " le " + fnFormatValue(ranges[1], true) + ")");
				}
				return "(" + rangeQuery.join(" and ") + ")";
			} else {
				return "(" + fieldName + " eq " + fnFormatValue(columnFilter) + ")";
			}
		}
	}]);

	return DateColumn;
}(_StringColumn3.default);

exports.default = DateColumn;


//////////////////
// WEBPACK FOOTER
// ./~/linksoft/data-tables/renderers/DateColumn.js
// module id = 489
// module chunks = 0